export default {
  s3: {
    REGION: 'us-west-2',
    BUCKET: 'fund-handle-dev-uploadsbucket-1d9v3c6gdwa1s',
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://a5z3s4rw8f.execute-api.us-west-2.amazonaws.com/dev',
  },
  cognito: {
    REGION: 'us-west-2',
    USER_POOL_ID: 'us-west-2_spCfhTYuJ',
    APP_CLIENT_ID: '1vkoj95hmdddjliu7s4aa9ipf',
    IDENTITY_POOL_ID: 'us-west-2:c28259e6-3bcd-482e-9d75-c27cf4fb6790',
  },
};
